// utils/lod.ts
export const normalizeLod = (lod?: string) =>
  (lod || '').trim().toLowerCase().replace(/[\s_-]/g, ''); // "School District" -> "schooldistrict"

const LOD_CANONICAL: Record<string, string> = {
  // collapse variants → your canonical values used by the backend payload
  schooldistrict: 'school',
  schools: 'school',
  school: 'school',

  county: 'county',
  tract: 'tract',
  blockgroup: 'block group',
  block_group: 'block group',
};

export const toCanonicalLod = (lod?: string): string | undefined => {
  const key = normalizeLod(lod);
  return LOD_CANONICAL[key] ?? key;
};
